const API_ENDPOINT = 'UserEmployeeProfilePermissionWhatsAppContents';

export const API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTask, 'id'>) =>
    `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTask, 'id'>) =>
    `${API_ENDPOINT}/Delete/${data.id}`,
  INSERT_BULK: `${API_ENDPOINT}/CreateUserEmployeeProfilePermissionWhatsAppContentBulk`,
};

export interface UserEmployeeProfilePermissionWhatsAppContentBulkInput {
  whatsappContentID: string;
  userEmployeeProfilePermissionIDs: string[];
}
